import { IssueModel, PlayModeModel, PlayDetailModel } from './betting.model';

export class CurrIssue {
    CurrentIssueNo: string;
    PreviewIssueNo: string;
    RemainTime: number;
    Issue: IssueModel;
}

export class PlaySelectModel {
    constructor() { }
    playMode: PlayModeModel = null;
    playDetailName: string = "";
    playDetail: PlayDetailModel = null;
    PlayGroup: string = "";
}


// WEBPACK FOOTER //
// ./src/models/bettingorder.dto.ts